import {
  Box,
  ClickAwayListener,
  DEPRECATED_REACT_PROPS,
  IconButton,
  Paper,
  Popper,
  Tooltip,
} from '@chronosphereio/chrono-ui';
import { Link as LinkIcon } from 'mdi-material-ui';
import { useCallback, useRef, useState } from 'react';
import { ContextLinkDefinition } from '../../../core';
import { ContextLinkEditor } from '../../../plugin-system/runtime/ContextLinkTypesProvider';

const ContextLinkToMarkdown = (link: ContextLinkDefinition) => {
  return `[${link.spec.title}](${link.spec.url})`;
};

export const MarkdownLinkButton = ({ onSave }: { onSave: (url: string) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorEl = useRef<HTMLButtonElement>(null);

  const openLinkForm = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const closeLinkForm = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleSave = useCallback(
    (contextLink: ContextLinkDefinition) => {
      onSave(ContextLinkToMarkdown(contextLink));
      closeLinkForm();
    },
    [onSave, closeLinkForm]
  );

  const handleClickAway = useCallback(
    (event: MouseEvent | TouchEvent) => {
      // TODO: If you click on a mui select inside of a ClickAwayListener, that click is through a portal so
      // it appears that it is a ClickAway.  Here we check if the target of the click is the body and if so,
      // assume that it came through a portal and don't treat it as a click away
      const body = document.querySelector('body');
      if (event.target !== body) {
        closeLinkForm();
      }
    },
    [closeLinkForm]
  );

  return (
    <>
      <Tooltip Content="Insert a link">
        <IconButton ref={anchorEl} onClick={openLinkForm}>
          <LinkIcon />
        </IconButton>
      </Tooltip>

      <Popper
        id={anchorEl.current === null ? 'markdown-link-popper-closed' : 'markdown-link-popper'}
        open={isOpen}
        anchorEl={anchorEl.current}
        sx={{ zIndex: 'modal' }}
        placement="bottom-end"
        {...DEPRECATED_REACT_PROPS}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper>
            <Box padding={1} sx={{ width: 300, maxHeight: 500, overflow: 'auto' }}>
              <ContextLinkEditor
                onSave={handleSave}
                onCancel={closeLinkForm}
                saveLabel="Insert link"
                cancelLabel="Cancel"
              />
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
